export default __webpack_public_path__ + "static/media/welcome_dashboards.be47c13f.png";